import axios from "axios";
import React from "react";
import * as yup from "yup";
import { INotes, noteSchema } from "./Notes";
import { contactSchema, IContact } from "./Contacts";
import { addressSchema, IAddress } from "./Address";

export interface IClient {
  id?: number;
  name: string;
  address: IAddress | null;
  logo?: string;
  folder?: string;
  sectors: number[];
  contacts: IContact[];
  notes: INotes[];
}

export const clientSchema: yup.SchemaOf<IClient> = yup.object({
  id: yup.number().optional(),
  name: yup.string().required("Name is a required field."),
  logo: yup.string().optional(),
  folder: yup.string().optional(),
  sectors: yup.array().of(yup.number().integer().required()).min(1),
  notes: yup.array().of(noteSchema).optional(),
  contacts: yup.array().of(contactSchema).optional(),
  address: addressSchema.nullable().optional(),
});

export interface IClientListItem {
  id: number;
  name: string;
  logo: string;
  folder: string;
  sectors: string[];
}

export interface IClientList {
  count: number;
  next: string | null;
  previous: string | null;
  results: IClientListItem[];
}

export const fetchClients = async (
  query: string
): Promise<void | IClientList> => {
  const response = await axios.get<IClientList>(`/clients/?${query}`);
  return response?.data;
};

export function useClients(query: string): [IClientList | null, boolean] {
  const [clients, setClients] = React.useState<IClientList | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<IClientList>(`/clients/?${query}`)
      .then((response) => {
        setClients(response.data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, [query]);

  return [clients, loading];
}

export function useClient(
  id: string | undefined
): [
  IClient | null,
  React.Dispatch<React.SetStateAction<IClient | null>>,
  boolean
] {
  const [client, setClient] = React.useState<IClient | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<IClient>(`/clients/${id}/`)
      .then((response) => {
        setClient(response.data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, [id]);
  return [client, setClient, loading];
}
